// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.checkbox-small-button {
  border-radius: 5px;
  align-items: center;
  background-color: #D1D3D4;
  border: 1px solid #A7A9AC;
  color: #333;
  display: flex;
  font-weight: 600;
  font-size: 0.8rem;
  margin: 10px;
  padding: 5px;
  min-width: 310px;
  width: 23%;
}
.checkbox-small-button input[type=checkbox] {
  width: 18px;
  height: 18px;
  background: white;
  margin-right: 10px;
}

.checked {
  background: #0669B3;
  border: 1px solid #0669B3;
  color: white;
}
.checked input[type=checkbox] {
  width: 18px;
  height: 18px;
  background: #0669B3;
  margin-right: 10px;
}

.tooltip-school > .tooltip-inner {
  background-color: #444343;
  opacity: 1;
  max-width: 100%;
}

.tooltip-school-container {
  background-color: #444343;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  opacity: 1;
  padding: 10px 5px;
  width: 100%;
}
.tooltip-school-container .school-details {
  position: relative;
  left: 0;
  text-align: left;
}
.tooltip-school-container .school-details .spacer {
  height: 10px;
}
.tooltip-school-container .school-details h6 {
  margin-left: 20px;
}
.tooltip-school-container .school-details span {
  font-size: 0.75rem;
  white-space: nowrap;
  margin-left: 20px;
}
.tooltip-school-container img {
  border-radius: 5px;
  background-color: white;
}

.tooltip-school > .tooltip-arrow {
  height: 50px;
  width: 50px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/CheckboxButton.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;ECAI,kBDCsB;EACtB,mBAAA;EACA,yBDaI;ECZJ,yBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AAUJ;AARI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAUR;;AAPA;EACI,mBAAA;EACA,yBAAA;EACA,YAAA;AAUJ;AARI;EACI,WAAA;EACA,YAAA;EACA,mBDPK;ECQL,kBAAA;AAUR;;AAPA;EACI,yBDbK;ECcL,UAAA;EACA,eAAA;AAUJ;;AARA;EACI,yBDlBK;ECmBL,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;AAWJ;AAVI;EACI,kBAAA;EACA,OAAA;EACA,gBAAA;AAYR;AAXQ;EACI,YAAA;AAaZ;AAXQ;EACI,iBAAA;AAaZ;AAXQ;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;AAaZ;AAVI;EC9DA,kBD+D0B;EACtB,uBAAA;AAYR;;AATA;EACI,YAAA;EACA,WAAA;AAYJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"./global/Colors.scss\";\n@import \"./global/globalMixins.scss\";\n\n.checkbox-small-button {\n    @include borderRadius(5px);\n    align-items: center;\n    background-color: $grey1;\n    border: 1px solid $grey2;\n    color: #333;\n    display: flex;\n    font-weight: 600;\n    font-size: 0.8rem;\n    margin: 10px;\n    padding: 5px;\n    min-width: 310px;\n    width: 23%;\n\n    input[type=\"checkbox\"] {\n        width: 18px;\n        height: 18px;\n        background:white;\n        margin-right: 10px;\n    }\n}\n.checked {\n    background: $pearl-blue;\n    border: 1px solid $pearl-blue;\n    color: white;\n\n    input[type=\"checkbox\"] {\n        width: 18px;\n        height: 18px;\n        background: $pearl-blue;\n        margin-right: 10px;\n    }\n}\n.tooltip-school > .tooltip-inner {\n    background-color: $grey4a;\n    opacity: 1;\n    max-width: 100%;\n}\n.tooltip-school-container {\n    background-color: $grey4a;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    opacity: 1;\n    padding: 10px 5px;\n    width: 100%;\n    .school-details {\n        position: relative;\n        left: 0;\n        text-align: left;\n        .spacer {\n            height: 10px;\n        }\n        h6 {\n            margin-left: 20px;\n        }\n        span {\n            font-size: 0.75rem;\n            white-space: nowrap;\n            margin-left: 20px;\n        }\n    }\n    img {\n        @include borderRadius(5px);\n        background-color: white;\n    }\n}\n.tooltip-school > .tooltip-arrow {\n    height: 50px;\n    width: 50px;\n}","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
